/* unplugin-vue-components disabled */import { render } from "./newsDetail.vue?vue&type=template&id=5f4d29ee&scoped=true"
import script from "./newsDetail.vue?vue&type=script&lang=js"
export * from "./newsDetail.vue?vue&type=script&lang=js"

import "../../assets/css/init/column.less?vue&type=style&index=0&id=5f4d29ee&lang=less&scoped=true"
import "../../assets/css/news/news.less?vue&type=style&index=1&lang=less"

import exportComponent from "/Users/iwowke/Desktop/work/www/iwowke.com/src/m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4d29ee"]])

export default __exports__